export const MALE = "Male";
export const FEMALE = "Female";